import * as React from "react";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import Stack from "@mui/material/Stack";
import { Button, } from "@mui/material";
import {ReactComponent as Sort} from "../../assets/ViewLeave-images/sort.svg"; 
import CheckIcon from "@mui/icons-material/Check";
const DEFAULT_SORT_OPTIONS = [{ label: "Date", value: "date" }, { label: "Name", value: "name" }];

export default function SortBy({handleSort, options = DEFAULT_SORT_OPTIONS}) {
  const [open, setOpen] = React.useState(false);
  const [selectedOption, setSelectedOption] = React.useState(null);
  const anchorRef = React.useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === "Escape") {
      setOpen(false);
    }
  }

  const handleSortSelection = (option) => {
    setSelectedOption(option);
    handleSort(option);
    setOpen(false);
  };

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <Stack direction="row" spacing={2}>
      <div>
        <Button  ref={anchorRef}
          id="composition-button"
          aria-controls={open ? "composition-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-haspopup="true" variant="contained" onClick={handleToggle} color="success" sx={{ borderRadius: 50, backgroundColor: "#28AA4A33", color: "#28AA4A", ml: "8px", textTransform: "none",height:"35px", fontSize: "12px", fontWeight: "400", width: "90px", px: "10px",boxShadow:"none","& .css-1d6wzja-MuiButton-startIcon":{mx:"3px"}}} startIcon={<Sort />}
        >
          {"Sort By"}
        </Button>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          placement="bottom-start"
          transition
          disablePortal
          sx={{zIndex:999999}}
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "bottom-start" ? "left top" : "left bottom",
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList
                    autoFocusItem={open}
                    id="composition-menu"
                    aria-labelledby="composition-button"
                    onKeyDown={handleListKeyDown}
                  >
                    {options.map((option) => (
                      <MenuItem key={option.value} sx={{fontSize:"14px",fontWeight:"400"}} onClick={() =>handleSortSelection(option.value)}>{option.label}{selectedOption === option.value && <CheckIcon fontSize="small" sx={{ ml: 1 }} />}</MenuItem>
                    ))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </Stack>
  );
}
